import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { FadeUp, Eyebrow } from "../components/motion";
import { API } from "../lib/site";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    document.title = "Curtain & Blinds Blog — Reef Deco Dubai";
    axios.get(`${API}/blog`).then((res) => setPosts(res.data.posts || [])).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  return (
    <main data-testid="blog-page" className="min-h-screen bg-sand-bg">
      <header className="border-b border-sand-border bg-white/80 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 h-[72px] flex items-center justify-between">
          <Link to="/" data-testid="blog-logo" className="flex items-center">
            <img src="/logo.png" alt="Reef Deco" className="h-9 w-auto" />
          </Link>
          <Link
            to="/"
            data-testid="blog-back-home"
            className="flex items-center gap-2 font-mono text-[11px] tracking-[0.18em] uppercase text-reef hover:text-reef-dark transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Back to site
          </Link>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 sm:py-20">
        <FadeUp>
          <Eyebrow className="mb-4">The Reef Deco journal</Eyebrow>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-slate-900 max-w-2xl">
            Curtain &amp; blinds ideas for <span className="italic text-reef">Dubai homes.</span>
          </h1>
          <p className="mt-5 max-w-xl text-base sm:text-lg text-slate-600 leading-relaxed">
            Fabric guides, climate tips and design inspiration from our installation team —
            after 350+ projects across Dubai.
          </p>
        </FadeUp>

        {loaded && posts.length === 0 && (
          <p data-testid="blog-empty" className="mt-16 text-slate-500 italic">No articles published yet — check back soon.</p>
        )}

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <FadeUp key={p.id} delay={i * 0.08}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${i}`} className="group block">
                <div className="relative overflow-hidden rounded-2xl aspect-[16/10] border border-sand-border bg-sand-soft">
                  {p.cover_image && (
                    <img
                      src={p.cover_image}
                      alt={p.title}
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                  )}
                </div>
                <p className="mt-4 font-mono text-[10px] tracking-[0.2em] uppercase text-reef">
                  {(p.created_at || "").slice(0, 10)}
                </p>
                <h2 className="mt-1.5 font-serif text-2xl text-slate-900 leading-snug group-hover:text-reef transition-colors flex items-start gap-2">
                  {p.title}
                  <ArrowUpRight className="w-5 h-5 mt-1 shrink-0 text-reef opacity-0 group-hover:opacity-100 transition-opacity" />
                </h2>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-2">{p.excerpt}</p>
              </Link>
            </FadeUp>
          ))}
        </div>
      </div>
    </main>
  );
}
